import React, { useState, useEffect, useRef } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import QuoteModal from "../QuoteModal/index.tsx";
import "./index.css";

export function Header() {
  const [open, setOpen] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const quoteBtnRef = useRef(null);

  const openModal = () => setQuoteOpen(true);
  const closeModal = () => {
    setQuoteOpen(false);
    setTimeout(() => quoteBtnRef.current?.focus(), 0);
  };

  // Close menu on resize back to desktop + scroll class + body scroll lock
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 960 && open) setOpen(false);
    };
    const onScroll = () => setScrolled(window.scrollY > 6);

    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // initialize

    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onScroll);
    };
  }, [open]);

  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  return (
    <header className={`hdr ${scrolled ? "is-scrolled" : ""}`}>
      <div className="container hdr__wrap">
        <a href="/" className="logo" aria-label="Home">
          <img
            src="/logo192.png"
            alt="BioClock SA Logo"
            className="logo__img"
          />
          <span className="logo__text">BioClock-in</span>
        </a>

        <button
          className="nav__toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen(!open)}
        >
          {open ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Backdrop for mobile sheet */}
        <div
          className={`nav__backdrop ${open ? "is-open" : ""}`}
          onClick={() => setOpen(false)}
          aria-hidden
        />

        <nav
          id="site-nav"
          className={`nav ${open ? "is-open" : ""}`}
          role="navigation"
        >
          <a
            href="#features"
            className="nav__link"
            onClick={() => setOpen(false)}
          >
            <span>Features</span>
          </a>
          <a
            href="#industries"
            className="nav__link"
            onClick={() => setOpen(false)}
          >
            <span>Industries</span>
          </a>
          <a href="#how" className="nav__link" onClick={() => setOpen(false)}>
            <span>How it works</span>
          </a>

          {/* Proper button for modal */}
          <button
            ref={quoteBtnRef}
            type="button"
            className="btn btn--sm btn--cta-ghost"
            onClick={() => {
              setOpen(false);
              openModal();
            }}
          >
            Get Demo
          </button>
        </nav>
      </div>

      <QuoteModal open={quoteOpen} onClose={closeModal} />
    </header>
  );
}
